/**
 * Copied from the backend. If this value change, we must ensure we communicate
 * with the backend team to ensure they are synchronized.
 *
 * @link https://github.com/hungryroot/hungryroot/blob/master/app/const.py
 */
export const REFERRAL_BONUS = 50;

/**
 * Copied from the backend. If this value change, we must ensure we communicate
 * with the backend team to ensure they are synchronized.
 *
 * @link https://github.com/hungryroot/hungryroot/blob/master/app/const.py
 */
export const MAX_GIFTS_PER_SEND = 10;

/**
 * Copied from the backend. If this value change, we must ensure we communicate
 * with the backend team to ensure they are synchronized.
 *
 * @link https://github.com/hungryroot/hungryroot/blob/master/app/const.py
 */
export const REFERRAL_DISCOUNT = 50;
